import { render, staticRenderFns } from "./printerManage.vue?vue&type=template&id=5944fa20&scoped=true&"
import script from "./printerManage.vue?vue&type=script&lang=js&"
export * from "./printerManage.vue?vue&type=script&lang=js&"
import style0 from "./printerManage.vue?vue&type=style&index=0&id=5944fa20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944fa20",
  null
  
)

component.options.__file = "printerManage.vue"
export default component.exports